<template>
  <div class="pecipeList">
    <div>
      <el-radio-group v-model="conditions" @change="tabConditions">
        <el-radio-button label="m">按月</el-radio-button>
        <el-radio-button label="y">按年</el-radio-button>
      </el-radio-group>
    </div>
    <el-form :inline="true" :model="searchForm" class="demo-form-inline" label-width="90px">
      <el-form-item label="月份区间" label-width="70px" v-if="conditions === 'm'">
        <el-date-picker
            @input="search"
            v-model="searchForm.monthTime"
            value-format="yyyy-MM-dd"
            type="monthrange"
            style="width: 220px"
            unlink-panels
            range-separator="至"
            start-placeholder="开始月份"
            end-placeholder="结束月份">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="年份区间" label-width="70px" v-if="conditions === 'y'">
        <el-date-picker
            @input="search"
            v-model="searchForm.startYear"
            type="year"
            value-format="yyyy"
            style="width: 220px"
            placeholder="开始年份"
            unlink-panels>
        </el-date-picker>
        -
        <el-date-picker
            @input="search"
            v-model="searchForm.endYear"
            type="year"
            style="width: 220px"
            value-format="yyyy"
            unlink-panels
            placeholder="结束年份">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="工号" label-width="60px">
        <el-input v-model="searchForm.workNum" size="medium" placeholder="请输入"></el-input>
      </el-form-item>
    </el-form>
    <div style="margin-bottom: 20px">
      <el-button @click="search">查询<i class="el-icon-search el-icon--right"></i></el-button>
      <el-button type="info" @click="clear">重置<i class="el-icon-refresh-right el-icon--right"></i></el-button>
      <!--      <el-button type="warning" style="float: right" @click="viewList">查看表格<i class="el-icon-view el-icon&#45;&#45;right"></i>-->
      <!--      </el-button>-->
    </div>
    <div style="border: 1px solid #c9cdd6">
      <el-table
          :header-cell-style="{background:'#F5F5F5'}"
          :data="tableData"
          border
          :span-method="objectSpanMethod"
          style="width: 100%"
      >
        <el-table-column
            prop="name"
            label="工人名字"
            width="180">
        </el-table-column>
<!--        <el-table-column-->
<!--            prop="workNO"-->
<!--            label="工人编号">-->
<!--        </el-table-column>-->
        <el-table-column
            prop="date"
            label="时间">
        </el-table-column>
        <el-table-column
            prop="maintainGood"
            label="保养好评数">
        </el-table-column>
        <el-table-column
            prop="maintainNormal"
            label="保养中评数">
        </el-table-column>
        <el-table-column
            prop="maintainBad"
            label="保养差评数">
        </el-table-column>
        <el-table-column
            prop="maintainAmount"
            label="保养总数">
        </el-table-column>
        <el-table-column
            prop="exceptionDealGood"
            label="异常处理好评数">
        </el-table-column>
        <el-table-column
            prop="exceptionDealGood"
            label="异常处理好评数">
        </el-table-column>
        <el-table-column
            prop="exceptionDealNormal"
            label="异常处理中评数">
        </el-table-column>
        <el-table-column
            prop="exceptionDealBad"
            label="异常处理差评数">
        </el-table-column>
        <el-table-column
            prop="exceptionDealAmount"
            label="异常处理总数">
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination.vue';
export default {
  name: "pecipeList",
  data() {
    return {
      tableData: [],
      searchForm: {
        monthTime: [],
        startYear: '2021',
        endYear: '2022',
      },
      total: 0, //总条数
      currPage: 1,//当前页码
      pageSize: 10, //每页条数
      conditions: 'm',
      OrderIndexArr: []
    }
  },
  components: {
    Pagination,
  },
  methods: {
    // -------------------查询条件/清空-------------------
    search() {
      this.tabConditions()
    },
    clear() {
      this.currPage = 1 //当前页码
      this.pageSize = 10 //每页条数
      this.searchForm = {
        monthTime: [],
        startYear: '2020',
        endYear: '2021',
        workNum: '',
      }
      this.tabConditions()
    },
    getOrderNumber() {
      let OrderObj = {}
      this.tableData.forEach((element, index) => {
        element.rowIndex = index
        if (OrderObj[element.name]) {
          OrderObj[element.name].push(index)
        } else {
          OrderObj[element.name] = []
          OrderObj[element.name].push(index)
        }
      })

      // 将数组长度大于1的值 存储到this.OrderIndexArr（也就是需要合并的项）
      for (let k in OrderObj) {
        if (OrderObj[k].length > 1) {
          this.OrderIndexArr.push(OrderObj[k])
        }
      }
    },
    objectSpanMethod({row, column, rowIndex, columnIndex}) {
      if (columnIndex === 0) {
        for (let i = 0; i < this.OrderIndexArr.length; i++) {
          let element = this.OrderIndexArr[i]
          for (let j = 0; j < element.length; j++) {
            let item = element[j]
            if (rowIndex == item) {
              if (j == 0) {
                return {
                  rowspan: element.length,
                  colspan: 1
                }
              } else if (j != 0) {
                return {
                  rowspan: 0,
                  colspan: 0
                }
              }
            }
          }
        }
      }
    },
    // viewList() {
    //   this.$router.push('/recipeStatistics/salesList')
    // },
    tabConditions() {
      let url = ''
      let data = {}
      let start, end
      if (this.conditions === 'm') {
        url = '/Statistics/PFExceptionDealStatistic/GetMonthAfterSaleStatistic'
        start = this.searchForm.monthTime[0]
        end = this.searchForm.monthTime[1]
      } else {
        url = '/Statistics/PFExceptionDealStatistic/GetYearAfterSaleStatistic'
        start = this.searchForm.startYear
        end = this.searchForm.endYear
      }
      data = {
        start: start,
        end: end,
        workNum : this.searchForm.workNum
      }
      this.init(url, data)
    },
    // list
    init(url, data) {
      this.axios
          .get(url, {params: data})
          .then((res) => {
            this.tableData=res
            this.tableData.forEach(item=>{
              item.date=item.year+'-'+item.month
            })
            this.getOrderNumber()
          })
    }
  },
  mounted() {
    //
    this.tabConditions()
  }
}
</script>

<style lang="scss" scoped>
.pecipeList {
  text-align: start;
  min-height: 800px;

  & > div:nth-child(1) {
    margin-bottom: 20px;

    .el-button {
      box-shadow: 0 4px 8px #FFE0BA;
    }
  }

  .decBox {
    padding-right: 20px;

    i {
      font-style: normal;
    }
  }

  .el-form {
    display: flex;
    flex-wrap: wrap;
  }

  .doctorDetails {
    .titleName {
      font-weight: bold;
      padding-right: 10px;
    }

    .detailsLine {
      padding-bottom: 20px;
    }

    .tagList {
      margin-right: 10px;
    }
  }
}
</style>